import React from "react";
import PropTypes from "prop-types";

import styles from "./StoryDescription.css";

export default function StoryDescription({ description }) {
  if (!description) return null;
  return <p className={styles.paragraph}>{description}</p>;
}

StoryDescription.propTypes = {
  description: PropTypes.string,
};
